import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Observable } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import { PilotHttpClient } from 'src/app/shared/flight-log-api/pilots/pilot-client.service';
import { PilotViewModel } from 'src/view-models/pilot-view-model';

@Component({
  selector: 'fl-pilot-manage-page',
  templateUrl: './pilot-manage-page.component.html',
  styleUrls: ['./pilot-manage-page.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PilotManagePageComponent implements OnInit {
  public pilot$: Observable<PilotViewModel | undefined>;
  public airCarrier = this._route.snapshot.data.airCarrier;

  constructor(private _route: ActivatedRoute, private _pilot: PilotHttpClient) {}

  public ngOnInit() {
    const pilotResult$ = this._route.params.pipe(
      map((p) => p.id),
      switchMap((id) => this._pilot.getById(id).pipe(map((r) => r))),
    );
    this.pilot$ = pilotResult$.pipe(map((res) => res.results[0]));
  }
}
